import React from 'react'

import { Theme } from '@mui/material/styles'

import Box from '@mui/material/Box'
import FormLabel from '@mui/material/FormLabel'

import { useHandlers } from './hooks'
import SearchToolTip from './SearchToolTip'
import { useReferralsContext } from '@user/components/Referrals/context'
import { TidalBillToSelect } from '@user/components/Location/BillToSelect/TidalBillToSelect'
import { TidalBillToCardBasic } from '@user/components/Location/BillToCardBasic'
import { TidalDiscountCodeSelect } from '@user/components/DiscountCodes/DiscountCodeSelect'
import { ReferralFormProps } from '@user/components/Referrals/components/UpdateReferral/UpdateReferralForm/UpdateReferralForm'
import Typography from '@mui/material/Typography'
import { ReferralFormVariant } from '@user/components/Referrals/components/UpdateReferral/TidalUpdateReferral'
import { BillToSearchSelect } from '@user/components/Location/BillToSelectScroll/BillToSearchSelect/BillToSearchSelect'

export function TidalCustomerContent(props: ReferralFormProps) {
  const { salesTeamId, formVariant } = props
  const [{ referralCustomerId, referralDiscountId, referralCustomerIdTemp }] =
    useReferralsContext()
  const { onClearClick, onCustomerChange, onDiscountChange, isInValid, error } =
    useHandlers(props)

  return (
    <Box>
      <Box mb="12px">
        {referralCustomerId &&
        !referralCustomerIdTemp &&
        formVariant === ReferralFormVariant.Drawer ? (
          <>
            <FormLabel sx={{ fontWeight: 500 }}>Selected Referral</FormLabel>
            <TidalBillToCardBasic
              onClearClick={onClearClick}
              billToId={referralCustomerId}
            />
          </>
        ) : (
          <>
            <Typography
              variant="body1"
              mb="12px"
              sx={{
                color: (theme: Theme) => theme.palette.text.secondary,
              }}
            >
              Add Customer
            </Typography>
            <Typography variant="body1" mb="12px">
              Search for a Bill-To Location
            </Typography>

            <SearchToolTip />
            {formVariant === ReferralFormVariant.Drawer ? (
              <TidalBillToSelect
                onClearClick={onClearClick}
                locationId={referralCustomerId}
                onChange={onCustomerChange}
                isInValid={isInValid}
                error={error}
              />
            ) : (
              <BillToSearchSelect
                locationId={referralCustomerId}
                onChange={onCustomerChange}
                onClearClick={onClearClick}
                isInValid={isInValid}
                error={error}
              />
            )}
          </>
        )}
      </Box>

      <Typography variant="body1" mb="12px">
        Apply Discount Code (Optional)
      </Typography>

      <TidalDiscountCodeSelect
        code={referralDiscountId}
        onChange={onDiscountChange}
        salesTeamId={salesTeamId}
      />
    </Box>
  )
}
